export function parseUrlPedidosFilter(query: any, adminProp?: boolean) {
  const { periodoini, periodofim, situacao, origem, tipoPedido, search, ...paginacao } = query;

  const buildPaginacaoResult = () => {
    if (Object.keys(paginacao).length > 0) {
      return {
        page: +paginacao.page || 1,
        itemsPerPage: +paginacao.itemsPerPage || 5,
        sortBy: paginacao.sortBy || [],
        sortDesc: paginacao.sortDesc || [],
        groupBy: paginacao.groupBy || [],
        groupDesc: paginacao.groupDesc || [],
        mustSort: paginacao.mustSort === "true",
        multiSort: paginacao.multiSort === "true"
      }
    }
    return null;
  }

  return {
    exibTodosCli: adminProp,
    ...(periodoini || periodofim ? { periodo: { dtIni: periodoini, dtFim: periodofim } } : null),
    origem: origem,
    situacao: situacao,
    tipoPedido: tipoPedido,
    search: search,
    pagination: buildPaginacaoResult()
  };

}